<template>
  <form-input
    v-bind="safeAttrs"
    v-model="value"
    :label="false"
    type="select2"
    :list="internalCurrencyList"
    :wrapper-margins="false"
    :auto-input-styleing="false">
  </form-input>
</template>

<script>
import CurrencyInputMixin from "@/client/extensions/mixins/baseComponents/form/controls/input/currencyInput.js";
import SimpleInputMixin from "@/client/extensions/mixins/baseComponents/form/controls/input/simpleInput.js";

export default {
  mixins: [SimpleInputMixin, CurrencyInputMixin],

  props: {
    translateList: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped></style>
